import { localCfg as config } from '../../../shared/config';
import { videoStore } from './stores';
export function extractAndSaveVideoList(payload) {
    let availableVideos = [];
    if (payload.hasOwnProperty('media_asset') &&
        payload.media_asset.file_attachments.length) {
        availableVideos = [...payload.media_asset.file_attachments];
    }
    const videos = getVideoMap(availableVideos);
    videoStore.update(s => (Object.assign(Object.assign({}, s), { videos })));
}
function getVideoMap(vidList) {
    const vidMap = {};
    vidList.forEach(o => {
        if (o.quality) {
            vidMap[o.quality] = { url: `${config.cdn}${o.file}`, mime: 'video/mp4' };
        }
    });
    return vidMap;
}
